customElements.get("product-form") ||
customElements.define(
  "product-form",
  class extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      if (!this.form) return;
      const idInput = this.form.querySelector("[name=id]");
      if (idInput) idInput.disabled = false;
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      this.cart =
        document.querySelector("cart-drawer") ||
        document.querySelector("cart-notification");
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton && document.querySelector("cart-drawer")) {
        this.submitButton.setAttribute("aria-haspopup", "dialog");
      }
    }

    onSubmitHandler(event) {
      event.preventDefault();
      if (!this.form) return;
      if (this.submitButton && this.submitButton.getAttribute("aria-disabled") === "true") return;

      this.cart =
        document.querySelector("cart-drawer") ||
        document.querySelector("cart-notification");
      if (this.cart && typeof this.cart.open === "function") {
        this.cart.open();
        if (typeof this.cart.setUpdating === "function") this.cart.setUpdating(true);
      }
      this.handleErrorMessage();
      if (this.submitButton) {
        this.submitButton.setAttribute("aria-disabled", "true");
        this.submitButton.classList.add("loading");
      }
      const spinner = this.querySelector(".loading-overlay__spinner");
      if (spinner) spinner.classList.remove("hidden");

      const fetchOptions = fetchConfig("javascript");
      fetchOptions.headers["X-Requested-With"] = "XMLHttpRequest";
      delete fetchOptions.headers["Content-Type"];

      const formData = new FormData(this.form);
      const isCollection =
        typeof document.body.classList.contains === "function" &&
        [].some.call(
          document.body.classList,
          (c) => c && c.indexOf("template-collection") === 0
        );
      if (isCollection) {
        formData.set("quantity", "1");
      }
      if (this.cart) {
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((s) => s.id)
        );
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      fetchOptions.body = formData;

      let cartAddUrl = typeof routes !== "undefined" ? routes.cart_add_url : "/cart/add";
      if (cartAddUrl.indexOf(".js") === -1) {
        cartAddUrl = cartAddUrl.split("?")[0].replace(/\/$/, "") + ".js";
      }
      fetch(cartAddUrl, fetchOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            this.handleErrorMessage(data.description);
            if (this.submitButton) {
              const soldOutMessage = this.submitButton.querySelector(
                ".sold-out-message"
              );
              if (soldOutMessage) {
                this.submitButton.setAttribute("aria-disabled", "true");
                const span = this.submitButton.querySelector("span");
                if (span) span.classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
              }
            }
            this.error = true;
            return;
          }

          if (!this.cart) {
            const retryOpenDrawer = () => {
              this.cart =
                document.querySelector("cart-drawer") ||
                document.querySelector("cart-notification");
              if (this.cart) {
                this.cart.renderContents(data);
                return;
              }
              if (window.routes?.cart_url) {
                window.location = window.routes.cart_url;
              }
            };
            setTimeout(retryOpenDrawer, 150);
            return;
          }

          this.error = false;
          const quickAddModal = this.closest("quick-add-modal");
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => this.cart.renderContents(data));
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(data);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          if (this.cart && typeof this.cart.setUpdating === "function") {
            this.cart.setUpdating(false);
          }
          if (this.submitButton) {
            this.submitButton.classList.remove("loading");
            if (!this.error) {
              this.submitButton.removeAttribute("aria-disabled");
            }
          }
          const spinner = this.querySelector(".loading-overlay__spinner");
          if (spinner) spinner.classList.add("hidden");
        });
    }

    handleErrorMessage(message = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector(".product-form__error-message-wrapper");
      if (this.errorMessageWrapper) {
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !message);
        if (message) {
          this.errorMessage.textContent = message;
        }
      }
    }
  }
);

$(document).ready(function () {
  $("variant-radios label").click(function () {
    setTimeout(function () {
      $(".product-form .product-form__submit").removeAttr("disabled");
    }, 300);
  });
});
